var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('h6',{staticClass:"mb-5"},[_vm._v("Valor total")]),_c('h5',{class:{
      'text-success': _vm.totalInNumber > 0,
      'text-danger': _vm.totalInNumber < 0
    }},[_vm._v(" "+_vm._s(_vm.loading ? "-" : _vm.total)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }